import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

function* basicSettingDetailssaga({ payload, callBack }) {
  try {
    const response = yield call(API.BASIC_SETTING_DETAILS, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.basicSettingDetails_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.basicSettingDetails_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.basicSettingDetails_Fail(response.data.error));
  }
}

function* getBasicDetailssaga({ payload, callBack }) {
  try {
    const response = yield call(API.GET_BASIC_DETAILS, payload);
    if (response.data.status == 200) {
      yield put(ACTION.getBasicDetails_Success(response.data));
    } else {
      yield put(ACTION.getBasicDetails_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.getBasicDetails_Fail(response.data.error));
  }
}

function* changePassOtp({ payload, callBack }) {
  try {
    const response = yield call(API.CHANGE_PASS_OTP, payload);
    if (response.data.status == 200) {
      yield put(ACTION.changePassOtp_Success(response.data));
    } else {
      yield put(ACTION.changePassOtp_Fail(response.data.error));
    }
    callBack && callBack(response.data);
  } catch (error) {
    yield put(ACTION.changePassOtp_Fail(response.data.error));
  }
}

function* changePassOtpVerify({ payload, callBack }) {
  try {
    const response = yield call(API.CHANGE_PASS_OTP_VERIFY, payload);
    if (response.data.status == 200) {
      yield put(ACTION.changePassOtpVerify_Success(response.data));
    } else {
      yield put(ACTION.changePassOtpVerify_Fail(response.data.error));
    }
    callBack && callBack(response.data);
  } catch (error) {
    yield put(ACTION.changePassOtpVerify_Fail(response.data.error));
  }
}

function* changePassAdmin({ payload, callBack }) {
  try {
    const response = yield call(API.CHANGE_PASS_ADMIN, payload);
    if (response.data.status == 200) {
      yield put(ACTION.changePassAdmin_Success(response.data));
    } else {
      yield put(ACTION.changePassAdmin_Fail(response.data.error));
    }
    callBack && callBack(response.data);
  } catch (error) {
    yield put(ACTION.changePassAdmin_Fail(response.data.error));
  }
}

function* SettingSaga() {
  yield takeEvery(CONST.BASIC_SETTING_DETAILS, basicSettingDetailssaga);
  yield takeEvery(CONST.GET_BASIC_DETAILS, getBasicDetailssaga);
  yield takeEvery(CONST.CHANGE_PASS_OTP, changePassOtp);
  yield takeEvery(CONST.CHANGE_PASS_OTP_VERIFY, changePassOtpVerify);
  yield takeEvery(CONST.CHANGE_PASS_ADMIN, changePassAdmin);
}

export default SettingSaga;
